import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    TextField,
    Stack,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate } from "react-router-dom";

const ProcessManagement = () => {
    const [open, setOpen] = useState(false);
    const [processData, setProcessData] = useState([]);
    const [newProcess, setNewProcess] = useState({
        name: "",
        description: "",
    });
    const [searchText, setSearchText] = useState("")
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");
    const decodedToken = token ? jwtDecode(token) : "";
    const navigate = useNavigate();
    const location = useLocation();



    const fetchProcessData = async (data) => {
        try {
            const res = await axiosInstance.get(
                apiEndPointsConfig?.processList,
                // data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setProcessData(res?.data?.data);
            setLoading(false);
        } catch (error) {
            const statusCode = error?.response?.data?.status?.code;
            if (statusCode === 401) {
                localStorage.clear();
            } else {
                console.error("Error while fetching dashboard details :", error);
            }
        }
    };

    useEffect(() => {
        fetchProcessData();
    }, []);

    console.log(processData, "processData");


    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setNewProcess({ name: "", description: "" });
        setOpen(false);
    };

    const handleChange = (e) => {
        setNewProcess({ ...newProcess, [e.target.name]: e.target.value });
    };

    const handleAddProcess = () => {
        if (!newProcess.name.trim()) return alert("Please enter a process name");
        const newEntry = {
            ...newProcess,
            qaParameters: 0,
            metrics: 0,
            entities: 0,
        };
        setProcessData([...processData, newEntry]);
        handleClose();
    };

    const filteredProcesses = processData.filter((item) =>
        item.process.toLowerCase().includes(searchText.toLowerCase())
    );


    return (
        <Box sx={{ p: 4, backgroundColor: "#f9fafb", minHeight: "80vh" }}>

            {/* Card Container */}
            <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 2 }}
                >
                    <Typography variant="h6" fontWeight="bold">
                        All Processes
                    </Typography>

                    <Stack direction="row" alignItems="center" spacing={2}>
                        <TextField
                            size="small"
                            placeholder="Search processes..."
                            sx={{ width: 260 }}
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={handleOpen}
                            sx={{
                                textTransform: "none",
                                backgroundColor: "#7635dc",
                                "&:hover": { backgroundColor: "#7635dc" },
                            }}
                        >
                            Add New Process
                        </Button>
                    </Stack>
                </Stack>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {processData.length} processes configured
                </Typography>

                {/* Table */}
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Process Name</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>QA Parameters</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Entities</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>OverView</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>CustomerInsight</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>AgentInsight</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Rediarization</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Conversion Insight</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredProcesses.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ fontWeight: 600 }}>{row.process}</TableCell>
                                    <TableCell>{row.description}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"qa-parameter"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/qa-parameter-prompt/${row.companyId}/${row.process}`, {
                                                    state: { from: location.pathname }
                                                }
                                                )
                                            }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            label={"enities"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/entities-prompt/${row.companyId}/${row.process}`, {
                                                    state: { from: location.pathname }
                                                }
                                                )
                                            }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            label={"overView"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/overview-prompt/${row.companyId}/${row.process}`, {
                                                    state: { from: location.pathname }
                                                }
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"customerInsight"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/customer-insight-prompt/${row.companyId}/${row.process}`, {
                                                    state: { from: location.pathname }
                                                }
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"agentInsight"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/agent-insight-prompt/${row.companyId}/${row.process}`, {
                                                    state: { from: location.pathname }
                                                }
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"rediarization"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/rediarization-prompt/${row.companyId}/${row.process}`, {
                                                    state: { from: location.pathname }
                                                }
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"ConversionInsight"}
                                            clickable
                                            disabled={row.process?.toLowerCase() !== "sales"}
                                            sx={{
                                                cursor:
                                                    row.process?.toLowerCase() === "sales"
                                                        ? "pointer"
                                                        : "not-allowed",
                                                backgroundColor:
                                                    row.process?.toLowerCase() === "sales"
                                                        ? "#7635dc"
                                                        : "#d1d5db",
                                                color:
                                                    row.process?.toLowerCase() === "sales"
                                                        ? "white"
                                                        : "#6b7280",
                                            }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/conversion-insight-prompt/${row.companyId}/${row.process}`, {
                                                    state: { from: location.pathname }
                                                }
                                                )
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: { borderRadius: 2, width: 500 },
                }}
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            Add New Process
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Create a new process to be used by clients.
                        </Typography>
                    </Box>
                    <IconButton onClick={handleClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <TextField
                        label="Name"
                        name="name"
                        variant="outlined"
                        fullWidth
                        value={newProcess.name}
                        onChange={handleChange}
                    />
                    <TextField
                        label="Description"
                        name="description"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        value={newProcess.description}
                        onChange={handleChange}
                    />
                </DialogContent>

                <DialogActions sx={{ pr: 3, pb: 2 }}>
                    <Button onClick={handleClose} sx={{ textTransform: "none" }}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleAddProcess}
                        sx={{
                            textTransform: "none",
                            backgroundColor: "#7635dc",
                            "&:hover": { backgroundColor: "#7635dc" },
                        }}
                    >
                        Complete
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
};

export default ProcessManagement;
